import { _post } from "../../../../apiClient";



let invitationJson;
let themeId = "1234";
let eventCode = "2222";

export default async function SaveData(sections) {
    if (sections && sections.length > 0) {
        let isValid = true;

        if (isValid) {
            invitationJson = {};
            console.log("savedata", sections);
            for (const section of sections) {
                if (section.sectionname === "theme") {
                    if (!await processingThemeDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                } 
                else if (section.sectionname === "events") {
                    if (!await processingEventDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                }
                 else if (section.sectionname === "invitation") {
                    if (!await processingInvitationDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                } 
                else if (section.sectionname === "community") {
                    if (!await processingCommunityDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                } 
                else if (section.sectionname === "gallery") {
                    if (!await processingGalleryDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                } 
                else if (section.sectionname === "subpeople") {
                    if (!await processingSubpeopleDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                }
                  else if (section.sectionname === "brand") {
                    if (!await processingBrandDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                }
                else if (section.sectionname === "articles") {
                    if (!await processingArticlesDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                } 
                else if (section.sectionname === "couple") {
                    if (!await processingCoupleDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                } 
                else if (section.sectionname === "people") {
                    if (!await processingPeopleDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                }
                 else if (section.sectionname === "customization") {
                    if (!await processingCustomDetails(section.data, eventCode)) {
                        invitationJson = null;
                        break;
                    }
                }
            }

            let postdata = {
                eventCode: eventCode,
                themeId: themeId,
                jsonData: JSON.stringify(invitationJson),
            };
            console.log("postdata", JSON.stringify(postdata, null, 2));
            console.log("invitationJson",invitationJson)
            return await createEvent(postdata);
        }
    }
}
const processingThemeDetails = async (themeData, eventCode) => {
    for (let i = 0; i < themeData.length; i++) {
        const item = themeData[i];
        const file = item.imageFile;

        if (file) {
            const key = await uploadImage("theme", file, eventCode, "theme-section");

            if (key) {
                item.imageKey = key;
            } else {
                console.error("Failed to upload image", file.name);
                return false; // Stop processing if any image fails to upload
            }
        }
    }

    // Save the final theme data into the invitationJson
    invitationJson.theme = themeData;
    return true;
};
const processingEventDetails = async (eventData, eventCode) => {
    console.log("processingEventDetails", eventData);
    if (eventData.imageFile) {
        const key = await uploadImage("mainEventImage", eventData.imageFile, eventCode, "events");
        eventData.imageKey = key;
      }
    if (eventData.awards && Array.isArray(eventData.awards)) {
        for (let award of eventData.awards) {
            if (award.imageFile) {
                const key = await uploadImage("awardImage", award.imageFile, eventCode, "events");
                award.imageKey = key; 
            }
        }
    }

    invitationJson.events = eventData;

    return true;
};
const processingInvitationDetails = async (eventData, eventCode) => {
    console.log("processingInvitationDetails", eventData);
    if (eventData.imageFile) {
        const key = await uploadImage("mainEventImage", eventData.imageFile, eventCode, "events");
        eventData.imageKey = key;
      }
    invitationJson.invitation = eventData;

    return true;
};
const processingCommunityDetails = async (eventData, eventCode) => {
    console.log("processingCommunityDetails", eventData);
    if (eventData.sliders && Array.isArray(eventData.sliders )) {
        for (let sliders of eventData.sliders) {
            if (sliders.imageFile) {
                const key = await uploadImage("awardImage", sliders.imageFile, eventCode, "events");
                sliders.imageKey = key; 
            }
        }
    }
    invitationJson.community = eventData;

    return true;
};
const processingGalleryDetails = async (eventData, eventCode) => {
    console.log("processingGalleryDetails", eventData);
  
    for (let sliders of eventData.imageFile) {
      if (sliders.imageFile) {
        const key = await uploadImage("awardImage", sliders.imageFile, eventCode, "events");
        sliders.imageKey = key;
      }
    }
  
    invitationJson.gallery = eventData.imageFile;
  
    return true;
  };
  const processingSubpeopleDetails = async (eventData, eventCode) => {
    console.log("processingSubpeopleDetails", eventData);
  
    for (let person of eventData.communitydata) {
      if (person.imageFile1) {
        const key1 = await uploadImage("awardImage", person.imageFile1, eventCode, "subpeople");
        person.imageKey1 = key1;
      }
  
      if (person.imageFile2) {
        const key2 = await uploadImage("awardImage", person.imageFile2, eventCode, "subpeople");
        person.imageKey2 = key2;
      }
    }
  
    invitationJson.subpeople = eventData;
  
    return true;
  };
  const processingBrandDetails = async (eventData, eventCode) => {
    console.log("processingBrandDetails", eventData);
  
    for (let sliders of eventData) {
      if (sliders.imageFile) {
        const key = await uploadImage("awardImage", sliders.imageFile, eventCode, "brand");
        sliders.imageKey = key;
      }
    }
  
    invitationJson.brand = eventData;
  
    return true;
  };
const processingCoupleDetails = async (eventData, eventCode) => {
    console.log("processingCoupleDetails", eventData);
    const dataformate = eventData[0].abouts;
    if (dataformate && Array.isArray(dataformate)) {
        for (let news of dataformate) {
            if (news.imageFile) {
                const key = await uploadImage("newsImage", news.imageFile, eventCode, "couple");
                news.imageKey = key; 
            }
        }
    }

    // Save updated data
    invitationJson.couple = eventData;

    return true;
};

  
  
  
  
  const processingArticlesDetails = async (eventData, eventCode) => {
    console.log("processingArticlesDetails", eventData);
  
    if (eventData.awards && Array.isArray(eventData.awards)) {
      for (let award of eventData.awards) {
        if (award.imageFile) {
          const key = await uploadImage("awardImage", award.imageFile, eventCode, "events");
          award.imageKey = key;
        }
      }
    }
  
    invitationJson.articles = eventData; 
  
    return true;
  };
  

const processingPeopleDetails = async (eventData, eventCode) => {
    console.log("processingPeopleDetails", eventData);
    if (eventData.imageFile) {
        const key = await uploadImage("customImage", eventData.imageFile, eventCode, "people");
        eventData.imageKey = key;
    }

    invitationJson.people = eventData;
    return true;
};



const processingCustomDetails = async (themeData, eventCode) => {
    console.log("processingCustomDetails", themeData);

    // Upload image if file is provided
    if (themeData.imageFile) {
        const key = await uploadImage("customImage", themeData.imageFile, eventCode, "customization");
        themeData.imageKey = key;
    }

    // Save to invitationJson
    invitationJson.customization = themeData;

    return true;
};


const uploadImage = async (imageType, file, eventCode, imageFrom) => {
    if (file) {
        let formData = new FormData();
        formData.append("ImageType", imageType);
        formData.append("EventCode", eventCode);
        formData.append("ImageFrom", imageFrom);
        formData.append("file", file);

        return await _post("/uploads/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
            return response.key || "";
        })
        .catch((error) => {
            console.error("Upload Error:", error);
            _showToast(error, "error");
            return "";
        });
    } else {
        console.error("No file provided for upload!");
        return "";
    }
};

const createEvent = async (postdata) => {
    console.log("postdata",postdata)
    return await _post("/events", postdata)
        .then((response) => {
            console.log("Event Created Successfully:", response);
            return { status: "success", message: "Event created successfully" };
        })
        .catch((error) => {
            console.error("Event Creation Failed:", error);
            return { status: "failed", message: error };
        });
};